import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUSES } from "./shared";

export function BookingsTab({ bookings, updateStatus, readOnly }) {
  return (
    <div className="rounded-lg border border-white/10 bg-card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-bookings-table">
          <thead>
            <tr className="border-b border-white/10 text-left text-muted-foreground text-xs uppercase tracking-luxe">
              <th className="px-5 py-4">Client</th>
              <th className="px-5 py-4">Service</th>
              <th className="px-5 py-4">Date</th>
              <th className="px-5 py-4">Source</th>
              <th className="px-5 py-4">Value</th>
              <th className="px-5 py-4">Payment</th>
              <th className="px-5 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b.id} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-testid={`admin-booking-${b.id}`}>
                <td className="px-5 py-4">
                  <p className="text-white">{b.name}</p>
                  <p className="text-muted-foreground text-xs">{b.email}</p>
                </td>
                <td className="px-5 py-4 text-white/80">{b.service_label}</td>
                <td className="px-5 py-4 text-white/80">{b.date}<br /><span className="text-muted-foreground text-xs">{b.time}</span></td>
                <td className="px-5 py-4 text-white/80">{b.lead_source || "—"}</td>
                <td className="px-5 py-4 text-white">${b.estimated_price}</td>
                <td className="px-5 py-4">
                  <span className={`text-xs ${b.payment_status === "deposit_paid" ? "text-white" : "text-muted-foreground"}`}>
                    {b.payment_status === "deposit_paid" ? "Deposit paid" : "Unpaid"}
                  </span>
                </td>
                <td className="px-5 py-4">
                  <Select value={b.status} onValueChange={(v) => updateStatus(b.id, v)} disabled={readOnly}>
                    <SelectTrigger data-testid={`status-select-${b.id}`} className="h-9 w-32 bg-secondary border-white/10 text-white text-xs disabled:opacity-60">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
            {bookings.length === 0 && (
              <tr><td colSpan={7} className="px-5 py-16 text-center text-muted-foreground">No bookings yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function CustomersTab({ customers }) {
  return (
    <div className="rounded-lg border border-white/10 bg-card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-customers-table">
          <thead>
            <tr className="border-b border-white/10 text-left text-muted-foreground text-xs uppercase tracking-luxe">
              <th className="px-5 py-4">Name</th>
              <th className="px-5 py-4">Email</th>
              <th className="px-5 py-4">Phone</th>
              <th className="px-5 py-4">Source</th>
              <th className="px-5 py-4">Signup</th>
              <th className="px-5 py-4">Bookings</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                <td className="px-5 py-4 text-white">{c.name || "—"}</td>
                <td className="px-5 py-4 text-white/80">{c.email}</td>
                <td className="px-5 py-4 text-white/80">{c.phone || "—"}</td>
                <td className="px-5 py-4 text-white/80">{c.lead_source || "—"}</td>
                <td className="px-5 py-4 text-muted-foreground text-xs">{(c.created_at || "").slice(0, 10)}</td>
                <td className="px-5 py-4 text-white">{c.bookings_count}</td>
              </tr>
            ))}
            {customers.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-16 text-center text-muted-foreground">No customers yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function DriversTab({ drivers }) {
  return (
    <div className="rounded-lg border border-white/10 bg-card overflow-hidden">
      <table className="w-full text-sm" data-testid="drivers-table">
        <thead>
          <tr className="border-b border-white/10 text-left text-muted-foreground text-xs uppercase tracking-luxe">
            <th className="px-5 py-4">Name</th><th className="px-5 py-4">Contact</th>
            <th className="px-5 py-4">Categories</th><th className="px-5 py-4">License</th><th className="px-5 py-4">Status</th>
          </tr>
        </thead>
        <tbody>
          {drivers.map((d) => (
            <tr key={d.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
              <td className="px-5 py-4 text-white">{d.name}</td>
              <td className="px-5 py-4 text-white/80">{d.email}<br /><span className="text-muted-foreground text-xs">{d.phone}</span></td>
              <td className="px-5 py-4 text-white/70 text-xs">{(d.vehicle_categories || []).join(", ")}</td>
              <td className="px-5 py-4 text-white/80">{d.license_info || "—"}</td>
              <td className="px-5 py-4"><span className={`text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-full border ${d.active ? "text-white border-white/40 bg-white/10" : "text-muted-foreground border-white/15"}`}>{d.active ? "Active" : "Inactive"}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
